import { API } from '@Providers';

export default async function () {
  const endpoint = '/api/shelter/foster-settings/get-foster-start-reasons';

  return API({ endpoint });
}
